import { useEffect } from 'react'
import { countEditorProbeRender } from '@/utils/editor/editorProbe'

export const useEditorProbeLifetime = (component: string): void => {
  useEffect(() => {
    countEditorProbeRender(`${component}.mount`)
    return () => countEditorProbeRender(`${component}.unmount`)
  }, [component])
}

export default useEditorProbeLifetime
